import { useState } from "react";
import axiosInstance from "../axiosInstance";
import { colors } from "../colors";

function AdminLogin({ setIsAdmin }) {
  const [showPassword, setShowPassword] = useState(false);

  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.post(
        "/auth/admin-login",
        credentials,
        { withCredentials: true }
      );
      // Check if login was actually successful
      if (response.data.message === "Login successful") {
        setIsAdmin(true);
      } else {
        setError(response.data.message || "Login failed.");
      }
    } catch (err) {
      console.error("Login failed:", err);
      setError(err.response?.data?.message || "Something went wrong.");
    }
  };


  return (
    <div className="flex h-screen items-center justify-center bg-white text-white">
      <div
        className="w-full max-w-md p-8  rounded-xl shadow-lg border-black"
        style={{ backgroundColor: "#EBEBEB" }}
      >
        <h2 className="text-2xl font-bold text-center mb-6 text-black">
          ADMIN LOGIN
        </h2>
        <form onSubmit={handleLogin} className="space-y-4">
          <input
            type="text"
            placeholder="Username"
            value={credentials.username}
            onChange={(e) =>
              setCredentials({ ...credentials, username: e.target.value })
            }
            required
            className="w-full p-3 rounded  text-black"
          />
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={credentials.password}
              onChange={(e) =>
                setCredentials({ ...credentials, password: e.target.value })
              }
              required
              className="w-full p-3 rounded text-black pr-12"
            />

            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-1/2 -translate-y-1/2"
              aria-label="Toggle password visibility"
            >
              {showPassword ? (
                /* OPEN EYE */
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              ) : (
                /* CLOSED EYE WITH LINE */
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
                  <circle cx="12" cy="12" r="3" />
                  <line x1="3" y1="3" x2="21" y2="21" />
                </svg>
              )}
            </button>
          </div>


          <button
            type="submit"
            className="w-full p-3 rounded  transition font-bold"
            style={{ backgroundColor: "black" }}
          >
            Login
          </button>
        </form>
        {error && (
          <p className="text-red-500 text-sm text-center mt-3">{error}</p>
        )}
      </div>
    </div>
  );
}

export default AdminLogin;
